import "./Confirmation.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Confirmation = (props) => {
  const { icon, title, subText, showFooter, isSuccessIcon, secondLine } = props;
  return (
    <div className="confirm-dialog-wrapper">
      <div className={isSuccessIcon ? "confirm-dialog-icon-wrapper" : "warning-dialog-icon-wrapper"}>
        <FontAwesomeIcon icon={icon} className={isSuccessIcon ? "dialog-success-icon" : "dialog-warning-icon"} />
      </div>
      <h2 className="confirm-dialog-title">{title} ?</h2>
      <span className="confirm-dialog-description">
        {subText} <br />
        {secondLine ? <span>{secondLine}</span> : null}
        {showFooter && <span>This action cannot be undone</span>}
      </span>
    </div>
  );
};

export default Confirmation;
